// src/components/MiniMonth.jsx
import React from "react";

/*
  MiniMonth: pequeño calendario mensual para la barra lateral.
  Props:
    - currentMonthDate (Date)
    - selectedDate (Date)
    - onSelectDate (fn)
    - onPrevMonth (fn)
    - onNextMonth (fn)
*/
export default function MiniMonth({ currentMonthDate, selectedDate, onSelectDate, onPrevMonth, onNextMonth }) {
  const monthStart = new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth(), 1);
  const totalDays = new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth()+1, 0).getDate();
  const firstWeekday = monthStart.getDay();
  const weekStartOffset = (firstWeekday + 6) % 7;
  const rows = [];
  for (let week = 0; week < 6; week++) {
    const cols = [];
    for (let wd = 0; wd < 7; wd++) {
      const cellIndex = week*7 + wd;
      const dayNumber = cellIndex - weekStartOffset + 1;
      if (dayNumber < 1 || dayNumber > totalDays) {
        cols.push(<td key={wd} style={{ height: 28 }} />);
      } else {
        const isSelected = selectedDate && selectedDate.getDate() === dayNumber && selectedDate.getMonth() === monthStart.getMonth() && selectedDate.getFullYear() === monthStart.getFullYear();
        cols.push(
          <td key={wd} style={{ height: 28, textAlign: 'center' }}>
            <button
              onClick={() => { const nd = new Date(monthStart); nd.setDate(dayNumber); nd.setHours(0,0,0,0); onSelectDate && onSelectDate(nd); }}
              style={{
                width:28, height:28, display:'inline-flex', alignItems:'center', justifyContent:'center',
                borderRadius:6, background: isSelected ? "#fff3d9": "transparent", border:'none', cursor:'pointer'
              }}
            >
              <span style={{ fontSize:12, color: isSelected ? "#6b4226" : "#0f172a" }}>{dayNumber}</span>
            </button>
          </td>
        );
      }
    }
    rows.push(<tr key={week}>{cols}</tr>);
  }
  const monthLabel = monthStart.toLocaleDateString("es-ES", { month: "long", year: "numeric" });
  return (
    <div style={{ background:'#fff', borderRadius:8, padding:12, boxShadow:"0 1px 2px rgba(15,23,42,0.04)" }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom:8 }}>
        <button onClick={onPrevMonth} aria-label="Mes anterior" style={{ border: 'none', background: 'transparent', cursor:'pointer', fontSize:14 }}>◀</button>
        <div style={{ fontSize:13, fontWeight:700 }}>{monthLabel}</div>
        <button onClick={onNextMonth} aria-label="Mes siguiente" style={{ border: 'none', background: 'transparent', cursor:'pointer', fontSize:14 }}>▶</button>
      </div>
      <table style={{ width:'100%', tableLayout:'fixed', textAlign:'center', fontSize:12 }}>
        <thead><tr style={{ color:'#94a3b8', fontSize:11 }}><th>L</th><th>M</th><th>X</th><th>J</th><th>V</th><th>S</th><th>D</th></tr></thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}